export { AddressDialogController as AddressDialog } from './address-dialog-controller';
